import React, { useEffect } from 'react';
import CVBuilder from '../../components/CVBuilder/CVBuilder';
import { useBreadcrumbSetter } from '../../hooks/useBreadcrumbSetter';
import './cv-builder.scss';

const CVBuilderPage: React.FC = () => {
  // Set breadcrumb for the page
  // useBreadcrumbSetter([
  //   { label: 'Beranda', path: '/dashboard' },
  //   { label: 'CV Builder', path: '/cv-builder' }
  // ]);

  // Add class to body to enable sticky positioning
  useEffect(() => {
    document.body.classList.add('cv-builder-active');
    return () => {
      document.body.classList.remove('cv-builder-active');
    };
  }, []);

  return (
    <div className="cv-builder-page">
      <CVBuilder />
    </div>
  );
};

export default CVBuilderPage;